(function(w, $){
	"use strict";
	
	var googleMap = function(){
		this.options = {
			aspectRatio: 0.6,
			center: {
				lat: 0,
				lng: 0
			},
			fitMarkers: false,
			cluster: false,
			zoom: 11
		};
		this.markers = [];
		
		this.requires = {
			googleMapsInit: 'http://maps.googleapis.com/maps/api/js?libraries=places&key=AIzaSyD-t03OGu_x2cLJDTjnWtf1k53qJzRj5wE',
		};
		
		return this;
	};
	
	$.extend(googleMap.prototype, {
		preInit: function(){
			this.$elem.height(this.$elem.width() * this.options.aspectRatio);
		},
		init: function(){
			var _self = this,
				elem = _self.$elem[0];
			
			_self.map = new w.google.maps.Map(elem, _self.options);
			
			$.each(_self.options.markers, function(){
				_self.addMarker(this);
			});
			
			_self.$elem.height(_self.$elem.width() * _self.options.aspectRatio);
			
			if(_self.options.fitMarkers){
				_self.fitMarkers();
			}
			
			if(_self.options.cluster){
				_self.clusterMarkers();
			}
			
		},
		setFocus: function(lat, lng){
			this.removeMarkers();
			
			this.map.panTo(new w.google.maps.LatLng(lat, lng));
			var marker = {
				position: {
					lat: lat,
					lng: lng
				}	
			};
			this.addMarker(marker);
			
		},
		addMarker: function(marker){
			marker.map = this.map;
			this.markers.push(new w.google.maps.Marker(marker));
		},
		removeMarkers: function(){
			$.each(this.markers, function(){
				this.setMap(null);
			});
		},
		fitMarkers: function(){
			var _self = this,
				bounds = new w.google.maps.LatLngBounds();
			
			$.each(_self.markers, function(){
				bounds.extend(this.getPosition());
			});
			
			_self.map.fitBounds(bounds);
			
		},
		clusterMarkers: function(){
			var cluster = new MarkerClusterer(this.map, this.markers, {imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'});
		}
	});
	
	w.brain.register('googleMap', googleMap);
	
	$(function(){
		$('.brain-googlemap').brGoogleMap();
	});
	
})(window, jQuery);